import React, { useState } from "react";
import { useDispatch } from "react-redux";
import SlidePanel from "../shared/SlidePanel";
import toast from "../shared/Toast";
import { marketingAction } from "../../_actions/marketing.actions";
import { ChannelCards, getSmsText } from "./MarketingEditorParts";

const URL_REGEX = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

function ReviewBoosterPanel({ data, salonId, onClose, onSaved }) {
  const dispatch = useDispatch();
  const isGoogle = data?.type === 1;
  const [reminder, setReminder] = useState({ ...data });
  const [reviewUrl, setReviewUrl] = useState(data?.reviewUrl || "");
  const [reviewUrlError, setReviewUrlError] = useState(null);
  const [saving, setSaving] = useState(false);

  const toggle = (field, checked) =>
    setReminder((r) => ({ ...r, [field]: checked ? 1 : 0 }));

  const onUrlChange = (e) => {
    const input = e.target.value;
    setReviewUrl(input);
    if (input === "" || URL_REGEX.test(input)) {
      setReviewUrlError(null);
    } else {
      setReviewUrlError("Enter valid url.");
    }
  };

  const save = () => {
    const next = { ...reminder };
    if (isGoogle) {
      if (
        (next.statusSMSreminder === 1 || next.statusEmailReminder === 1) &&
        !reviewUrl
      ) {
        setReviewUrlError("Google review url is required.");
        return;
      }
      next.reviewUrl = reviewUrl;
    }
    const payload = { reminders: [next], type: 6, salonId };
    setSaving(true);
    dispatch(marketingAction.updateSetting(payload))
      .then((res) => {
        setSaving(false);
        if (res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message);
          if (onSaved) onSaved();
        }
      })
      .catch(() => setSaving(false));
  };

  const footer = (
    <>
      <button type="button" className="sp-btn-secondary" onClick={onClose}>
        Cancel
      </button>
      <button type="button" className="sp-btn-primary" onClick={save} disabled={saving}>
        Save
      </button>
    </>
  );

  return (
    <SlidePanel
      title={isGoogle ? "Review Booster" : data?.title}
      onClose={onClose}
      footer={footer}
      width={520}
    >
      <p className="sp-hint" style={{ marginTop: 0 }}>
        {isGoogle
          ? "Automatically send your client a request to leave a Google review after their appointment."
          : data?.note}
      </p>

      {isGoogle && (
        <>
          <a
            className="mep-help-link"
            href="https://support.google.com/business/answer/3474122?hl=en-GB"
            target="_blank"
            rel="noopener noreferrer"
          >
            How to find your Google Review Link
          </a>
          <div className="sp-field" style={{ marginTop: 16 }}>
            <label className="sp-label">Add Google Review URL</label>
            <input
              type="text"
              className="sp-input"
              value={reviewUrl || ""}
              onChange={onUrlChange}
              placeholder="https://g.page/..."
            />
            {reviewUrlError ? <div className="sp-error">{reviewUrlError}</div> : null}
          </div>
        </>
      )}

      <ChannelCards
        smsDesc={
          <>
            SMS messages are sent to <b>all clients</b> to the phone number you have
            saved on client record.
          </>
        }
        emailDesc={
          <>
            Emails are sent to <b>all clients</b> to the email address you have saved on
            their client record.
          </>
        }
        statusSMS={reminder?.statusSMSreminder}
        statusEmail={reminder?.statusEmailReminder}
        onToggleSms={(c) => toggle("statusSMSreminder", c)}
        onToggleEmail={(c) => toggle("statusEmailReminder", c)}
        smsText={getSmsText("googleReview")}
        emailType="Google Review Booster"
      />
    </SlidePanel>
  );
}

export default ReviewBoosterPanel;
